_ = require 'underscore'

isValidDataImage = (url) ->
  _.isString(url) &&
  /^data:image\/(?:png|jpg|jpeg|gif);base64,[A-Za-z0-9+\/=_-]+$/.test(url)

isValidHttp = (url) ->
  _.isString(url) &&
  /^https?:\/\//.test(url)

isValidUrlForImage = (url) ->
  isValidHttp(url) || isValidDataImage(url)

# when putting image URLs in CSS, we don't want you to be able
# to escape the CSS property with a ' or " and try to set other
# css properties behind our backs
isValidUrlForCSSImage = (url) ->
  isValidUrlForImage(url) && !/['"]/.test(url)

isValidUrlForIframe = (url) ->
  isValidHttp(url)

isValidHeight = (height, maxHeight = Infinity) ->
  if !height? || !_.isNumber(height)
    return false
  return height >= 1 && height <= maxHeight

module.exports = {
  isValidHeight,
  isValidUrlForImage,
  isValidUrlForCSSImage,
  isValidUrlForIframe
}



// WEBPACK FOOTER //
// ./app/scripts/lib/util/plugin-validators.coffee